import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { ILocationHistoryRegistration } from '@obvious.tech/constellation'

export const LocationHistoryRegistration = defineEntity(
  'LocationHistoryRegistration',
  {
    endpoint: 'geolocation/api/LocationHistoryRegistration',
    schema: SNoop<ILocationHistoryRegistration>(),
  },
)
